export default __webpack_public_path__ + "static/media/icon_company_resources.54c4f8c8.svg";